import React from 'react';
import { IAuditoriaProvisaoEspelhoResultado } from '../interfaces/IAuditoriaProvisaoEspelho';

interface Props {
  resultado: IAuditoriaProvisaoEspelhoResultado;
  onVerDetalhe: () => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const formatDate = (dateStr?: string) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('pt-BR');
};

const AuditoriaResumoProvisaoEspelho: React.FC<Props> = ({ resultado, onVerDetalhe }) => {
  const bordaCor =
    resultado.status === 'ERRO'   ? '#f64e60' :
    resultado.status === 'ALERTA' ? '#ffa800' :
    resultado.status === 'AVISO'  ? '#ffa800' :
                                    '#1bc5bd';

  const badgeCor =
    resultado.status === 'ERRO'   ? 'danger' :
    resultado.status === 'ALERTA' ? 'warning' :
    resultado.status === 'AVISO'  ? 'warning' :
                                    'success';

  return (
    <div
      className='card card-custom card-stretch mb-5'
      style={{ borderLeft: `4px solid ${bordaCor}` }}
    >
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>
            Provisões "Espelho" — Cookie Jar Accounting
          </span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            Contas 2.01.04.xx · 2.02.04.xx · 3.01.01.07.xx · 3.01.03.02.xx (CPC 25)
          </span>
        </h3>
        <div className='card-toolbar'>
          <span className={`badge badge-light-${badgeCor} fs-7 fw-bold`}>
            {resultado.status}
          </span>
        </div>
      </div>

      <div className='card-body pt-3'>
        <div className='row mb-4'>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{resultado.totalErros}</div>
            <div className='text-muted fs-7'>Erros (≥ R$ 10k)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAlertas}</div>
            <div className='text-muted fs-7'>Alertas (&lt; R$ 10k)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAvisos}</div>
            <div className='text-muted fs-7'>Avisos (&lt; 5% diff)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{formatCurrency(resultado.passivoTributarioTotal)}</div>
            <div className='text-muted fs-7'>Passivo Tributário</div>
          </div>
        </div>

        {resultado.status !== 'CONCILIADO' && resultado.itens.length > 0 && (
          <div className='table-responsive mb-4'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Conta</th>
                  <th>Valor Espelho</th>
                  <th>Constituição</th>
                  <th>Reversão</th>
                  <th>Intervalo</th>
                  <th>Passivo</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {resultado.itens.slice(0, 5).map((item, i) => (
                  <tr key={i}>
                    <td>
                      <span className='fw-bold'>{item.descricaoConta}</span>
                      <br />
                      <span className='text-muted fs-8'>{item.contaReferencial}</span>
                    </td>
                    <td className='fw-bold'>{formatCurrency(item.valorEspelho)}</td>
                    <td>{formatDate(item.dataConstituicao)}</td>
                    <td>{formatDate(item.dataReversao)}</td>
                    <td>
                      <span className={`fw-bold ${item.status === 'ERRO' ? 'text-danger' : 'text-warning'}`}>
                        {item.diferencaTemporal} mês(es)
                      </span>
                    </td>
                    <td className='text-danger fw-bold'>{formatCurrency(item.passivoTributario)}</td>
                    <td>
                      <span className={`badge badge-light-${item.status === 'ERRO' ? 'danger' : 'warning'}`}>
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {resultado.status === 'CONCILIADO' && (
          <div className='text-success fw-bold fs-6'>
            ✓ Nenhum par espelho de provisão detectado. Situação regular.
          </div>
        )}

        <button className='btn btn-sm btn-light-primary mt-2' onClick={onVerDetalhe}>
          Ver detalhes
        </button>
      </div>
    </div>
  );
};

export default AuditoriaResumoProvisaoEspelho;
